import ElectricityIcon from '@enerex/unified-ui-react/icons/ElectricityIcon';
import GasIcon from '@enerex/unified-ui-react/icons/GasIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDroplet, faWater, faCloud, faTemperatureHigh, faSnowflake } from '@fortawesome/free-solid-svg-icons';
import { findCommodityIcon } from './commodityIcons';

const ICONS = {
    electric: ElectricityIcon, electricity: ElectricityIcon, electricityicon: ElectricityIcon,
    bolt: ElectricityIcon, 'fa-bolt': ElectricityIcon, el: ElectricityIcon,
    gas: GasIcon, naturalgas: GasIcon, gasicon: GasIcon, fire: GasIcon, 'fa-fire': GasIcon, ng: GasIcon,
};
const FONT_AWESOME_ICONS = {
    'fa-droplet': faDroplet, 'fa-water': faWater, 'fa-cloud': faCloud,
    'fa-temperature-high': faTemperatureHigh, 'fa-snowflake': faSnowflake,
};
const normalize = value => String(value ?? '').trim().toLowerCase().replace(/\s+/g, '');
export const getCommodityIcon = row => {
    const hyperIcon = findCommodityIcon(row.commodityIcon)?.value;
    if (['mdi mdi-lightning-bolt', 'mdi mdi-flash'].includes(hyperIcon)) return ElectricityIcon;
    if (hyperIcon === 'mdi mdi-fire') return GasIcon;
    return hyperIcon || ICONS[normalize(row.commodityIcon)] || ICONS[normalize(row.name)] || ICONS[normalize(row.abbreviation)];
};
export const getCommodityColor = (value, Icon) => {
    const color = typeof value === 'string' ? value.trim() : '';
    const defaultColor = Icon === ElectricityIcon || ['mdi mdi-lightning-bolt', 'mdi mdi-flash'].includes(Icon) ? 'var(--ct-warning, #ffc35a)'
        : Icon === GasIcon || Icon === 'mdi mdi-fire' ? 'var(--ct-success, #0acf97)' : 'var(--ct-primary, #700096)';
    return color && typeof CSS !== 'undefined' && CSS.supports('color', color)
        ? color : defaultColor;
};

const CommodityName = ({ commodity }) => {
    const Icon = getCommodityIcon(commodity);
    return <span className="settings-lookup__commodity-name">
        <span className="settings-lookup__commodity-icon-slot" aria-hidden="true">
            {FONT_AWESOME_ICONS[Icon] ? <FontAwesomeIcon icon={FONT_AWESOME_ICONS[Icon]} className="settings-lookup__commodity-icon"
                color={getCommodityColor(commodity.commodityColor, Icon)} aria-hidden="true" />
                : typeof Icon === 'string' ? <i className={Icon} style={{ color: getCommodityColor(commodity.commodityColor, Icon), fontSize: 16, lineHeight: 1 }} aria-hidden="true" />
                : Icon && <Icon className="settings-lookup__commodity-icon" color={getCommodityColor(commodity.commodityColor, Icon)} aria-hidden="true" />}
        </span>
        <span>{commodity.name ?? '—'}</span>
    </span>;
};
export default CommodityName;
